<template>
  <div>
    <div class="page-header page-header-small" style="z-index:2;">
      <parallax
        class="page-header-image"
        style="background-image: url('img/background.jpg')!important;background-color:rgba(0,0,0,0)!important;"
      >
      </parallax>
      <div class="content-center">
        <div class="container">
          <h1 class="title">PRIVACY POLICY</h1>
        </div>
      </div>
    </div>
    <div style="padding: 3rem!important;padding-top:0px!important;margin-top:-90px;">
      <div style="border-radius: 15px;background-color:#f2f0f0;z-index: 3;" class="section section-about-us">
      <div class="container" style="width:100%;padding:4rem;">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title">Privacy Policy and Cookies</h2>
          </div>
        </div>
        <div class="separator separator-primary"></div>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
   line-height:normal;mso-outline-level:1;">
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:0cm;text-align:justify;text-indent:-18.0pt;line-height:18.0pt;
   mso-list:l0 level1 lfo1;tab-stops:list 36.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.0pt;mso-bidi-font-size:10.5pt;font-family:Symbol;
      mso-fareast-font-family:Symbol;mso-bidi-font-family:Symbol;color:#333333"><span style="mso-list:Ignore">·<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">
      This Privacy Policy (the "Policy") is designed to tell
      User about the practices regarding collection, use, and disclosure of
      Information that may be collected by Company through various online modes (i.e.
      website or mobile application) and offline modes (i.e. letters, phone or in
      person). Please be sure to read this entire Privacy Policy and the Terms &amp;
      Conditions, available on the Company's Sites, before using or submitting any
      Information through the Company Sites or any other modes.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:36.0pt;text-align:justify;text-indent:-18.0pt;line-height:18.0pt;
   mso-list:l0 level2 lfo1;tab-stops:list 72.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      Arial;color:#333333"><span style="mso-list:Ignore">1.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;
   </span></span></span><!--[endif]--><b><span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">Definitions</span></b>
              <span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">
      <br>
      Unless otherwise provided in this Privacy Policy, the terms capitalized in the
      Privacy Policy shall have the meaning as provided hereunder:
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:72.0pt;text-align:justify;text-indent:-18.0pt;line-height:18.0pt;
   mso-list:l0 level3 lfo1;tab-stops:list 108.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.0pt;mso-bidi-font-size:10.5pt;font-family:Wingdings;
      mso-fareast-font-family:Wingdings;mso-bidi-font-family:Wingdings;color:#333333"><span style="mso-list:Ignore">§<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      "<b>Co-Branded Services</b>" shall
      have the meaning assigned to the term in paragraph 6 D(iii) hereto.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:72.0pt;text-align:justify;text-indent:-18.0pt;line-height:18.0pt;
   mso-list:l0 level3 lfo1;tab-stops:list 108.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.0pt;mso-bidi-font-size:10.5pt;font-family:Wingdings;
      mso-fareast-font-family:Wingdings;mso-bidi-font-family:Wingdings;color:#333333"><span style="mso-list:Ignore">§<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      "<b>Customer</b>" or "<b>User</b>"
      shall mean and include any person using the Sites or Services of the Company.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:72.0pt;text-align:justify;text-indent:-18.0pt;line-height:18.0pt;
   mso-list:l0 level3 lfo1;tab-stops:list 108.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.0pt;mso-bidi-font-size:10.5pt;font-family:Wingdings;
      mso-fareast-font-family:Wingdings;mso-bidi-font-family:Wingdings;color:#333333"><span style="mso-list:Ignore">§<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      "<b>Device</b>" shall mean computer,
      laptop, mobile, tablet or any other electronic / mechanical equipment used to
      access the Services.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:72.0pt;text-align:justify;text-indent:-18.0pt;line-height:18.0pt;
   mso-list:l0 level3 lfo1;tab-stops:list 108.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.0pt;mso-bidi-font-size:10.5pt;font-family:Wingdings;
      mso-fareast-font-family:Wingdings;mso-bidi-font-family:Wingdings;color:#333333"><span style="mso-list:Ignore">§<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      "<b>Personal Information</b>" or
      "<b>Protected Information</b>" or "<b>Information</b>"
      shall mean and include Customer's name, date of birth, e-mail address, mobile
      number, credit card information, shipping and billing address, etc. collected
      by Company through various online modes (i.e. website or mobile application)
      and offline modes (i.e. letters, phone or in person).
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:72.0pt;text-align:justify;text-indent:-18.0pt;line-height:18.0pt;
   mso-list:l0 level3 lfo1;tab-stops:list 108.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.0pt;mso-bidi-font-size:10.5pt;font-family:Wingdings;
      mso-fareast-font-family:Wingdings;mso-bidi-font-family:Wingdings;color:#333333"><span style="mso-list:Ignore">§<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      "<b>Privacy Policy</b>" or "<b>Policy</b>"
      shall mean this Privacy Policy.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:72.0pt;text-align:justify;text-indent:-18.0pt;line-height:18.0pt;
   mso-list:l0 level3 lfo1;tab-stops:list 108.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.0pt;mso-bidi-font-size:10.5pt;font-family:Wingdings;
      mso-fareast-font-family:Wingdings;mso-bidi-font-family:Wingdings;color:#333333"><span style="mso-list:Ignore">§<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span></span><!--[endif]--><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">"<b>Sites</b>" shall mean the
   Company's website (</span><span class="MsoHyperlink"><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;"><a href="https://www.trasnpoindia.in/">https://www.trasnpoindia.in/</a></span></span>
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      ) and/or mobile application.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:72.0pt;text-align:justify;text-indent:-18.0pt;line-height:18.0pt;
   mso-list:l0 level3 lfo1;tab-stops:list 108.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.0pt;mso-bidi-font-size:10.5pt;font-family:Wingdings;
      mso-fareast-font-family:Wingdings;mso-bidi-font-family:Wingdings;color:#333333"><span style="mso-list:Ignore">§<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      "<b>Services</b>" shall mean and
      include any services provide by the Company.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:72.0pt;text-align:justify;text-indent:-18.0pt;line-height:18.0pt;
   mso-list:l0 level3 lfo1;tab-stops:list 108.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.0pt;mso-bidi-font-size:10.5pt;font-family:Wingdings;
      mso-fareast-font-family:Wingdings;mso-bidi-font-family:Wingdings;color:#333333"><span style="mso-list:Ignore">§<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      "<b>TPSP</b>" shall mean a
      third-party service provider.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:72.0pt;text-align:justify;text-indent:-18.0pt;line-height:18.0pt;
   mso-list:l0 level3 lfo1;tab-stops:list 108.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.0pt;mso-bidi-font-size:10.5pt;font-family:Wingdings;
      mso-fareast-font-family:Wingdings;mso-bidi-font-family:Wingdings;color:#333333"><span style="mso-list:Ignore">§<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      "<b>Usage Information</b>" shall
      have the meaning assigned to the term in paragraph 4(C) hereto.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:36.0pt;text-align:justify;text-indent:-18.0pt;line-height:18.0pt;
   mso-list:l0 level2 lfo1;tab-stops:list 72.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      Arial;color:#333333"><span style="mso-list:Ignore">2.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;
   </span></span></span><!--[endif]--><b><span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">Consent</span></b>
              <span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">
      <br>
      By using the Sites, User agrees to the terms of this Privacy Policy and Terms
      &amp; Conditions of the Company. Whenever User submits Information via the
      Sites or any other modes, User consents to the collection, use and disclosure
      of that Information in accordance with this Privacy Policy.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:36.0pt;text-indent:-18.0pt;line-height:18.0pt;mso-list:l0 level2 lfo1;
   tab-stops:list 72.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      Arial;color:#333333"><span style="mso-list:Ignore">3.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;
   </span></span></span><!--[endif]--><b><span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">Scope and Application</span></b>
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      <br>
      This Privacy Policy applies to the Customer using the Company's Sites or
      Services, this Privacy Policy does not apply to Information Company collects
      from or about drivers, couriers, partner transportation companies, or any other
      persons who use Company's Sites.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:36.0pt;text-indent:-18.0pt;line-height:18.0pt;mso-list:l0 level2 lfo1;
   tab-stops:list 72.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      Arial;color:#333333"><span style="mso-list:Ignore">4.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;
   </span></span></span><!--[endif]--><b><span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">Information Collected</span></b>
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      <br style="mso-special-character:line-break">
                  <!--[if !supportLineBreakNewLine]--><br style="mso-special-character:line-break">
                  <!--[endif]-->
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:72.0pt;text-indent:-18.0pt;line-height:18.0pt;mso-list:l0 level3 lfo1;
   tab-stops:list 108.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.0pt;mso-bidi-font-size:10.5pt;font-family:Wingdings;
      mso-fareast-font-family:Wingdings;mso-bidi-font-family:Wingdings;color:#333333"><span style="mso-list:Ignore">§<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      Personal Information:<br>
      Company uses fair and proper means to collect the Personal Information (which
      means information about a living individual which can identify the specific
      individual by name, date of birth or other description contained in such
      information (including such information as will allow easy reference to other
      information and will thereby enable the identification of the specific
      individual) such as name, date of birth, e-mail address, mobile number, credit
      card information, shipping and billing address, etc.) to the extent necessary
      to achieve the purpose for use prescribed in this Privacy Policy.<br>
      Company may collect this information through various means and in various places
      through the Services, including account registration forms, contact us forms,
      or when User otherwise interact with Company. When User sign up to use the
      Services, User creates a user profile.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:72.0pt;text-indent:-18.0pt;line-height:18.0pt;mso-list:l0 level3 lfo1;
   tab-stops:list 108.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.0pt;mso-bidi-font-size:10.5pt;font-family:Wingdings;
      mso-fareast-font-family:Wingdings;mso-bidi-font-family:Wingdings;color:#333333"><span style="mso-list:Ignore">§<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      Information Collected Automatically:<br>
      Company also automatically collects IP address and referring website address,
      browser type, domain name and website access frequency. This information is
      intended to help facilitate User's online experience on the Sites. Company uses
      cookies to track usage patterns on the Sites and to control the display of ads,
      as well as to offer other functionalities. User can turn off cookies, but that
      will affect the online experience.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:72.0pt;text-align:justify;text-indent:-18.0pt;line-height:18.0pt;
   mso-list:l0 level3 lfo1;tab-stops:list 108.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.0pt;mso-bidi-font-size:10.5pt;font-family:Wingdings;
      mso-fareast-font-family:Wingdings;mso-bidi-font-family:Wingdings;color:#333333"><span style="mso-list:Ignore">§<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      Information Company collect as User access
      Company Sites and uses Services: In addition to any Protected Information or
      other Information that User choose to submit to Company, the Company and its
      TPSP may use a variety of technologies that automatically (or passively)
      collect certain information whenever User visits or interacts with the Services
      ("Usage Information"). This Usage Information may include the browser
      that User are using, the URL that referred User to Company's Services, all of
      the areas within Company's Services that User visits, and the time of day,
      among other information.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:72.0pt;text-indent:-18.0pt;line-height:18.0pt;mso-list:l0 level3 lfo1;
   tab-stops:list 108.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.0pt;mso-bidi-font-size:10.5pt;font-family:Wingdings;
      mso-fareast-font-family:Wingdings;mso-bidi-font-family:Wingdings;color:#333333"><span style="mso-list:Ignore">§<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      Device Information:<br>
      Company collects information about mobile device, including the hardware model,
      operating system and version, software and file names and versions, preferred
      language, unique device identifier, advertising identifiers, serial number,
      device motion information, and mobile network information.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:72.0pt;text-indent:-18.0pt;line-height:18.0pt;mso-list:l0 level3 lfo1;
   tab-stops:list 108.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.0pt;mso-bidi-font-size:10.5pt;font-family:Wingdings;
      mso-fareast-font-family:Wingdings;mso-bidi-font-family:Wingdings;color:#333333"><span style="mso-list:Ignore">§<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp; </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      Log Information:<br>
      Company also collects server logs, which may include information like device IP
      address, access dates and times, app features or pages viewed, app crashes and
      other system activity, type of browser, and the third-party site or service
      User were using before interacting with Company's Services.<br>
      In case of booking via call centre, Company may record calls for quality and
      training purposes.<br>
      In addition, tracking information is collected as User navigates through
      Company's Services, including, but not limited to geographic areas. The
      driver's mobile phone will send GPS coordinates, during the ride, to Company
      servers. Most GPS enabled mobile devices can define one's location to within 50
      feet.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:36.0pt;text-indent:-18.0pt;line-height:18.0pt;mso-list:l0 level2 lfo1;
   tab-stops:list 72.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      Arial;color:#333333"><span style="mso-list:Ignore">5.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;
   </span></span></span><!--[endif]--><b><span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">Purposes of Use of Collected Information</span></b>
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      <br>
      Company uses information other than Personal Information that User provides for
      the purpose of fulfillment of the requests and improvement of the Sites and
      materials contained thereon and for any other purposes which the Company deem
      reasonable and necessary. Company may, from time to time, produce reports for
      advertisers, sponsors, group companies and vendors containing anonymous,
      aggregate information about its Users, such as demographic, age and online
      Usage Information. This information allows Company to provide content and
      offers that are most relevant to its Users to work more closely with
      advertisers. The Company doesn't include any Personal Information of its Users
      in these reports.<br>
      <br>
      Company uses Personal Information only for the purpose described in this
      Privacy Policy or not otherwise. Company uses Personal Information so that it
      may supply specific information requested by Customers, undertake surveys or
      competitions, etc., manage orders for products and services, display or send
      custom, personalized content to its Users and send newsletters, mail, e-mails,
      features, promotional material, surveys and other updates, information or
      offers to its Users. Company also uses collected Information to evaluate and
      administer Company's products and Services, fulfill Customers request, respond
      to any future problems, such as difficulties in navigating Company's Sites or
      accessing certain features, and to gauge User trends to determine what products
      and Services are most popular with Users. Other uses of Personal Information
      are described on each Site page on which User records their Personal
      Information. Company may combine Personal Information with other collected
      information for the purposes of use unless otherwise specified.<br>
      <br>
      The Company will send User strictly Service-related announcements on rare
      occasions when it is necessary to do so. For instance, if its Services are
      temporarily suspended for maintenance, the Company might send User an email. If
      User do not wish to receive them, User has the option to deactivate its
      account.<br>
      <br>
      The Company provide some of the Protected Information (such as name, pick up
      address, contact number) to the driver who accepts User's request for
      transportation so that the driver may contact and find User. The companies for
      which drivers work (that are providing the transportation service) are also
      able to access Protected Information, including the geo-location data.<br>
      <br>
      The Company uses that geo-location information for various purposes, including
      for User to be able to view the drivers in its area that are close to the
      location, for User to set their pick up location, for the drivers to identify
      their pick-up location, to send User promotions and offers, and to allow User
      (if User choose through any features Company may provide) to share this
      information with other people.<br>
      <br>
      In addition, the Company may use the Protected Information or Usage Information
      that the Company collects about User:
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:72.0pt;text-align:justify;text-indent:-72.0pt;mso-text-indent-alt:
   -18.0pt;line-height:18.0pt;mso-list:l0 level3 lfo2;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      Arial;color:#333333"><span style="mso-list:Ignore"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span>i.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">
      to provide User with information or Services or process
      transactions that User has requested or agreed to receive including to send
      electronic newsletters, or to provide with special offers or promotional
      materials on behalf of Company or third parties;
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:72.0pt;text-align:justify;text-indent:-72.0pt;mso-text-indent-alt:
   -18.0pt;line-height:18.0pt;mso-list:l0 level3 lfo2;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      Arial;color:#333333"><span style="mso-list:Ignore"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span>ii.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">
      to enable User to participate in a variety of the Services'
      features such as online or mobile entry sweepstakes, contests or other
      promotions;
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:72.0pt;text-align:justify;text-indent:-72.0pt;mso-text-indent-alt:
   -18.0pt;line-height:18.0pt;mso-list:l0 level3 lfo2;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      Arial;color:#333333"><span style="mso-list:Ignore"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span>iii.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">
      to contact User with regard to the use of the Services and in
      Company's discretion, changes to the Services and/or the Service policies;
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:72.0pt;text-align:justify;text-indent:-72.0pt;mso-text-indent-alt:
   -18.0pt;line-height:18.0pt;mso-list:l0 level3 lfo2;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      Arial;color:#333333"><span style="mso-list:Ignore"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span>iv.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">
      for internal business purposes;
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:72.0pt;text-align:justify;text-indent:-72.0pt;mso-text-indent-alt:
   -18.0pt;line-height:18.0pt;mso-list:l0 level3 lfo2;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      Arial;color:#333333"><span style="mso-list:Ignore"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span>v.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">
      for inclusion in Company's data analytics; and
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:72.0pt;text-align:justify;text-indent:-72.0pt;mso-text-indent-alt:
   -18.0pt;line-height:18.0pt;mso-list:l0 level3 lfo2;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      Arial;color:#333333"><span style="mso-list:Ignore"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span>vi.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">
      for purposes disclosed at the time User provides the Information
      or as otherwise set forth in this Privacy Policy.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:0cm;margin-left:
   36.0pt;margin-bottom:.0001pt;text-align:justify;line-height:18.0pt;background:
   white">
   <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;
      mso-fareast-font-family:&quot;Times New Roman&quot;;color:#333333">
      <br>
      The Company may use the Information collected from User for targeted
      advertising. This involves using information collected from User's web or
      mobile browsing behavior such as the pages the User has visited or the searches
      User has made. This information is then used to select which advertisements
      should be displayed to a particular User on websites other than the Company's
      Sites. The information collected is only linked to an anonymous cookie ID
      (alphanumeric number); it does not include any information that could be linked
      back to a User, such as their name, address or credit card number
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:36.0pt;text-indent:-18.0pt;line-height:18.0pt;mso-list:l0 level2 lfo2;
   tab-stops:list 72.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      Arial;color:#333333"><span style="mso-list:Ignore">6.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;
   </span></span></span><!--[endif]--><b><span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">Sharing of Collected Information</span></b>
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      <br>
      Company may share User's Personal Information with such statutory and legal
      authorities as may be required under the existing laws. Save and except for the
      above Company is not permitted to sell or otherwise disclose User's Personal
      Information to TPSP except as authorized by the User, or as permitted or
      required by law.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:72.0pt;text-indent:-72.0pt;mso-text-indent-alt:-18.0pt;line-height:
   18.0pt;mso-list:l0 level3 lfo3;tab-stops:list 108.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.0pt;mso-bidi-font-size:10.5pt;font-family:Wingdings;
      mso-fareast-font-family:Wingdings;mso-bidi-font-family:Wingdings;color:#333333"><span style="mso-list:Ignore"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span>§<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp; </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      Shared Personal Information:<br>
      User's name, address, telephone number, gender, date of birth, occupation,
      e-mail address, etc.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:72.0pt;text-indent:-72.0pt;mso-text-indent-alt:-18.0pt;line-height:
   18.0pt;mso-list:l0 level3 lfo3;tab-stops:list 108.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.0pt;mso-bidi-font-size:10.5pt;font-family:Wingdings;
      mso-fareast-font-family:Wingdings;mso-bidi-font-family:Wingdings;color:#333333"><span style="mso-list:Ignore"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span>§<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp; </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      Purposes &amp; use of shared Information:<br>
      Personal Information is shared to enable joint users to supply specific
      information requested by Customers, undertake surveys or competitions, etc.,
      manage products and Services, display or send custom, personalized content to
      Users and send newsletters, mail, e-mails, features, promotional material,
      surveys and other updates, information or offers to Users.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:72.0pt;text-indent:-72.0pt;mso-text-indent-alt:-18.0pt;line-height:
   18.0pt;mso-list:l0 level3 lfo3;tab-stops:list 108.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.0pt;mso-bidi-font-size:10.5pt;font-family:Wingdings;
      mso-fareast-font-family:Wingdings;mso-bidi-font-family:Wingdings;color:#333333"><span style="mso-list:Ignore"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span>§<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp; </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      Sharing of Information not Containing Personal
      Information:<br>
      Company may share anonymous, aggregate demographic information, and anonymous
      information obtained from cookies and similar technologies, with its sponsors,
      promotional and business partners, and participating vendors. No Personal
      Information, such as credit card information, is disclosed to any of these
      third parties in sharing such anonymous information.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:72.0pt;text-align:justify;text-indent:-72.0pt;mso-text-indent-alt:
   -18.0pt;line-height:18.0pt;mso-list:l0 level3 lfo3;tab-stops:list 108.0pt;
   ">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.0pt;
      mso-bidi-font-size:10.5pt;font-family:Wingdings;mso-fareast-font-family:Wingdings;
      mso-bidi-font-family:Wingdings;color:#333333"><span style="mso-list:Ignore"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span>§<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp; </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      Company do not sell, share, rent or trade the
      Information, that Company has collected about User, other than as disclosed
      within this Privacy Policy or at the time User provide the Information.
      Following are the situations when information may be shared:
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:108.0pt;text-indent:-108.0pt;mso-text-indent-alt:-18.0pt;
   line-height:18.0pt;mso-list:l0 level4 lfo3;tab-stops:list 144.0pt;background:
   white">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:Arial;color:#333333"><span style="mso-list:Ignore"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span>i.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">
      When User agrees to receive Information from TPSP:-<br>
      User may be presented with an opportunity to receive Information and/or
      marketing offers directly from TPSP. If User do agree to have the Protected
      Information shared, the Protected Information will be disclosed to such TPSP
      and all Information User disclose will be subject to the privacy policy and
      practices of such TPSP. The Company is not responsible for the privacy policies
      and practices of such TPSP and, therefore, User should review the privacy policies
      and practices of such TPSP prior to agreeing to receive such Information from
      them. If User later decides that User no longer want to receive communication
      from TPSP, User will need to contact the TPSP directly.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:108.0pt;text-indent:-108.0pt;mso-text-indent-alt:-18.0pt;
   line-height:18.0pt;mso-list:l0 level4 lfo3;tab-stops:list 144.0pt;background:
   white">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:Arial;color:#333333"><span style="mso-list:Ignore"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span>ii.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">
      TPSP providing Services on Company's behalf:-<br>
      Company uses third party companies and individuals to provide or perform
      certain aspects of the Services on Company's behalf to facilitate the Services,
      to host the Services, design and/or operate the Services' features, track the
      Services' analytics, process payments, engage in anti-fraud and security
      measures, provide customer support, provide geo-location information to
      Company's drivers, enable Company to send special offers, host Company's job
      application form, perform technical services (e.g. without limitation,
      maintenance services, database management, web analytics and improvement of the
      Services‘ features), or perform other administrative services. These TPSP will
      have access to User's Information, including Protected Information to only carry
      out the services they are performed for User or for Company. Each of these TPSP
      are required to ensure the same level of data protection as the Company and are
      obligated not to disclose or use Protected Information for any other purpose.
      Analytics TPSPs may set and access their own cookies, web beacons and embedded
      scripts on User's Device and they may otherwise collect or have access to
      information about User, including non-personally identifiable information. The
      Company uses a third party hosting provider who hosts Company's support section
      of Company's Sites. Information collected within this section of Company's
      Sites by such third party is governed by this Privacy Policy.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:108.0pt;text-indent:-108.0pt;mso-text-indent-alt:-18.0pt;
   line-height:18.0pt;mso-list:l0 level4 lfo3;tab-stops:list 144.0pt;background:
   white">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:Arial;color:#333333"><span style="mso-list:Ignore"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span>iii.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">
      Co-Branded Services:-<br>
      Certain aspects of the Services may be provided to User in association with
      TPSP ("<b>Co-Branded Services</b>") such as sponsors and charities
      and may require User to disclose Protected Information to them. Such Co-Branded
      Services will identify the third party. If User elects to register for products
      and/or services through the Co Branded Services, User shall have deemed to
      consent to providing the Information to both Company and the third party.
      Further, if User sign-in to a Co Branded Service with a username and password
      obtained through Company's Services, the Protected Information may be disclosed
      to the identified third parties for that Co-Branded Service and will be subject
      to their posted privacy policies.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:108.0pt;text-indent:-108.0pt;mso-text-indent-alt:-18.0pt;
   line-height:18.0pt;mso-list:l0 level4 lfo3;tab-stops:list 144.0pt;background:
   white">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:Arial;color:#333333"><span style="mso-list:Ignore"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span>iv.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">
      Contests and Promotions:-<br>
      Company may offer promotions through the Services that may require
      registration. By participating in a promotion, User is agreeing to official
      rules that govern that promotion, which may contain specific requirements of
      User, including, allowing the sponsor of the promotion to use the name, voice
      and/or likeness in advertising or marketing associated with the promotion. If
      User chooses to enter a promotion, User agrees that the Protected Information
      may be disclosed to third parties or the public in connection with the
      administration of such promotion, including, in connection with winner
      selection, prize fulfillment, and as required by law or permitted by the
      promotion's official rules, such as on a winners list.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:108.0pt;text-indent:-108.0pt;mso-text-indent-alt:-18.0pt;
   line-height:18.0pt;mso-list:l0 level4 lfo3;tab-stops:list 144.0pt;background:
   white">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:Arial;color:#333333"><span style="mso-list:Ignore"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span>v.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">
      When User share Information:-<br>
      Protected Information may be collected and shared with TPSP if there is content
      from the Device that User specifically and knowingly upload to, share with or
      transmit to an email recipient, online community, website, or to the public,
      e.g. uploaded photos, posted reviews or comments, or information about User or
      the ride that User choose to share with others through features which may be
      provided on Company's Services. This uploaded, shared or transmitted content
      will also be subject to the privacy policy of the email, online community
      website, social media or other platform to which User upload, share or transmit
      the content
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:108.0pt;text-indent:-108.0pt;mso-text-indent-alt:-18.0pt;
   line-height:18.0pt;mso-list:l0 level4 lfo3;tab-stops:list 144.0pt;background:
   white">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:Arial;color:#333333"><span style="mso-list:Ignore"><span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span>vi.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   </span></span></span><!--[endif]-->
              <span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">
      Business Transfer:-<br>
      Company may share User's Information, including User's Protected Information
      and Usage Information with its parent, subsidiaries and affiliates for internal
      reasons. Company also reserve the right to disclose and transfer all such
      information: (i) to a subsequent owner, co-owner or operator of the Services or
      applicable database; or (ii) in connection with a corporate merger,
      consolidation, restructuring, the sale of substantially all of Company
      membership interests and/or assets or other corporate change, including, during
      the course of any due diligence process.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:36.0pt;text-indent:-18.0pt;line-height:18.0pt;mso-list:l0 level2 lfo3;
   tab-stops:list 72.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      Arial;color:#333333"><span style="mso-list:Ignore">7.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;
   </span></span></span><!--[endif]--><b><span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">Supply of Information to Customers</span></b>
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      <br>
      Company may extend e-mail offers to Users or Customers on behalf of Company's
      business partners about a particular product or service that may be of interest
      to User without sharing the name or e-mail address with or disclosing the name
      or e-mail address to those business partners, of course, User may opt out of
      receiving these offers at any time.<br>
      <br>
      Sometimes Company will give User the opportunity to opt in to receive e-mail
      offers from TSPS not affiliated with Company. If User decides to accept these
      offers, Company will provide, upon the consent, the contact information to the
      TSPS. Company urges Users to review carefully the privacy policies of these
      firms. Company is not responsible for the privacy policies and procedures of
      any third party.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:36.0pt;text-indent:-18.0pt;line-height:18.0pt;mso-list:l0 level2 lfo3;
   tab-stops:list 72.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      Arial;color:#333333"><span style="mso-list:Ignore">8.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;
   </span></span></span><!--[endif]--><b><span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">Credit Card Companies</span></b>
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      <br>
      In the event that User choose to transact using a credit card, Company will
      supply to the credit card company all relevant Information about the name and
      other service details, trip date, total cost and other information necessary to
      process the transaction. Company will not otherwise provide any Personal
      Information to the credit card company without User's permission.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:36.0pt;text-indent:-18.0pt;line-height:18.0pt;mso-list:l0 level2 lfo3;
   tab-stops:list 72.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      Arial;color:#333333"><span style="mso-list:Ignore">9.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;&nbsp;&nbsp;
   </span></span></span><!--[endif]--><b><span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">Disclosure to Third Parties</span></b>
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      <br>
      Company will not disclose the Personal Information to any TPSP without the
      consent; provided, however, that Company reserves the right to use or disclose
      to TPSP any information without a Customer's consent in the following
      circumstances: (i) if it is requested by any laws and regulations; (ii) If
      Company deems it necessary for protection and security of human life, body or
      assets;(iii) If Company deems it particularly necessary for cooperation with a
      governmental body or other public organization or its designee in discharging
      its duties pursuant to the laws and regulations (including investigating breach
      of laws), or otherwise deems it particularly necessary for the public interest;
      (iv) if Company outsources the handling of Personal Information to the extent
      necessary for its business operation.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:36.0pt;text-indent:-18.0pt;line-height:18.0pt;mso-list:l0 level2 lfo3;
   tab-stops:list 72.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      Arial;color:#333333"><span style="mso-list:Ignore">10.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;
   </span></span></span><!--[endif]--><b><span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">Information collected by drivers:-</span></b>
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      <br>
      This Privacy Policy shall not cover the usage of any Information about User
      which is obtained by the driver or the company to which the driver belongs,
      while providing a ride on a cab booked using the Services, or otherwise, which
      is not provided by Company.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:36.0pt;text-align:justify;text-indent:-18.0pt;line-height:18.0pt;
   mso-list:l0 level2 lfo3;tab-stops:list 72.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      Arial;color:#333333"><span style="mso-list:Ignore">11.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;
   </span></span></span><!--[endif]--><b><span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">Cookies</span></b>
              <span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">
      <br>
      User's web browser offers so-called "cookies" which, if User allows
      their use, store small amounts of data on the computer when User visit a
      website. Cookies do not contain any Personal Information about User and
      therefore cannot be used to identify User personally. However, cookies assist
      Company in tracking which of Company's features User like best. Therefore,
      cookies enable Company to customize its content according to the preferences.
      User has the ability to accept or decline cookies by modifying the browser
      settings. Company Sites are viewable even if User disables the cookie function
      on the browser. However, if User disables cookies, some advanced and customized
      features will not be available to User.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:36.0pt;text-indent:-18.0pt;line-height:18.0pt;mso-list:l0 level2 lfo3;
   tab-stops:list 72.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      Arial;color:#333333"><span style="mso-list:Ignore">12.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;
   </span></span></span><!--[endif]--><b><span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">Web Beacons</span></b>
              <span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">
      <br>
      Some of Company web pages may contain electronic images known as web beacons,
      which are also called "single-pixel gifs". These images allow Company
      to count Users who have visited those pages and to deliver Co-Branded Services.
      Company may also include web beacons in promotional e-mail messages or
      newsletters in order to count how many messages have been opened and acted
      upon. Web beacons are not used to access the Personal Information but there is
      a technique Company use to compile aggregated statistics about usage on the
      Sites. Web beacons collect only a limited range of information including the
      time and date of page view, cookie number and description of the page on which
      the web beacon resides.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:36.0pt;text-indent:-18.0pt;line-height:18.0pt;mso-list:l0 level2 lfo3;
   tab-stops:list 72.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      Arial;color:#333333"><span style="mso-list:Ignore">13.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;
   </span></span></span><!--[endif]--><b><span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">Social Media Features and Widgets</span></b>
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      <br>
      Company's online and mobile Services may include social media features, such as
      the Facebook like button, and widgets such as a "Share This" button,
      or interactive mini programs that run on Company's online and mobile Services.
      These features may collect IP address, photograph, which page Users are
      visiting on Company's online or mobile Services, and may set a cookie to enable
      the feature to function properly. Social media features and widgets are either
      hosted by a TPSP or hosted directly on Company's online Services. User's
      interactions with these features and widgets are governed by the privacy policy
      of the company providing them.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:36.0pt;text-indent:-18.0pt;line-height:18.0pt;mso-list:l0 level2 lfo3;
   tab-stops:list 72.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      Arial;color:#333333"><span style="mso-list:Ignore">14.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;
   </span></span></span><!--[endif]--><b><span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">Security of Personal Information</span></b>
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      <br>
      Company uses the latest technology to encrypt important information, such as
      credit card data, in an effort to prevent unauthorized access during
      transmission of orders over the Internet. Company implements standard industry
      practices internally and with its service providers to maintain the security of
      User's Personal Information depending on its sensitivity and to avoid
      disclosure of such Personal Information unpermitted under this Privacy Policy.<br>
      <br>
      Although Company has implemented systems and procedures to secure the data
      maintained by Company, security during Internet transmissions can never be
      assured. Company policy is to limit access to Personal Information to those
      Company employees or agents with a specific need to access or retrieve the
      Information. Company stores data on multiple service systems, in controlled
      environments. To maintain security, Company conducts internal reviews of its
      security measures on a regular basis. WHILE COMPANY HAS TAKEN COMMERCIALLY
      REASONABLE PRECAUTIONS TO SAFEGUARD PERSONAL INFORMATION, COMPANY CANNOT AND
      DOES NOT GUARANTEE COMPLETE SECURITY OF PERSONAL INFORMATION BECAUSE COMPLETE
      SECURITY DOES NOT PRESENTLY EXIST ON THE INTERNET.<br>
      <br>
      Where User have chosen a password which enables User to access certain parts of
      Company Sites, User is responsible for keeping this password confidential.
      Company asks User not to share a password with anyone.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:36.0pt;text-indent:-18.0pt;line-height:18.0pt;mso-list:l0 level2 lfo3;
   tab-stops:list 72.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      Arial;color:#333333"><span style="mso-list:Ignore">15.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;
   </span></span></span><!--[endif]--><b><span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">Changes in Corporate Structure</span></b>
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      <br>
      In developing Company's business, Company may engage in the sale or transfer of
      certain assets and the Company itself, or parts of it, may be sold, merged or
      otherwise assigned. In such transactions and changes in ownership, User's
      Information, whether personally identifiable or otherwise, may constitute one
      of the transferred assets. If required by law, Company will notify affected Users
      of such transfer or assignment in accordance with the procedure for changing
      this Privacy Policy described below.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal" style="mso-margin-top-alt:auto;margin-bottom:11.25pt;
   margin-left:36.0pt;text-indent:-18.0pt;line-height:18.0pt;mso-list:l0 level2 lfo3;
   tab-stops:list 72.0pt;">
              <!--[if !supportLists]--><span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      Arial;color:#333333"><span style="mso-list:Ignore">16.<span style="font:7.0pt &quot;Times New Roman&quot;">&nbsp;
   </span></span></span><!--[endif]--><b><span lang="EN-US" style="font-size:10.5pt;
      font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:&quot;Times New Roman&quot;;
      color:#333333">Changes in this Privacy Policy</span></b>
              <span lang="EN-US" style="font-size:10.5pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:
      &quot;Times New Roman&quot;;color:#333333">
      <br>
      Company will occasionally update this Privacy Policy as necessary to protect
      Company's Users and to accommodate a changing environment. The changes to this
      Privacy Policy will be deemed to be effective from the date of posting on Sites
      unless Company specify otherwise. Company recommends that User should check the
      Privacy Policy when User visit Company's Sites to be sure that User are aware
      of and understand Company's current policy. If Company makes material changes
      to this Privacy Policy, Company will make efforts to prominently post such
      changes prior to implementing the change. Company will not make any retroactive
      material changes in how Company handle previously collected Personal
      Information unless User allows Company to do so, or unless Company is legally
      required to do so, and in such a case Company will make efforts to inform
      registered visitors of information on material changes to this Privacy Policy.
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal">
   <span lang="EN-US">
      <o:p>&nbsp;</o:p>
   </span>
          </p>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import { Button, FormGroupInput } from '@/components';
export default {
  name: 'privacy-policy',
  bodyClass: 'landing-page',
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
  data() {
    return {
      form: {
        firstName: '',
        email: '',
        message: ''
      }
    };
  }
};
</script>
<style>
  .wrapper {
    background-color: #94969c;
  }
</style>
